// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hd-0";